import { useContext } from "react";
import Checkbox from "../../Checkbox/Checkbox";
import { ConfigurationContext, DispatchContext } from "./ConfigurationContext";
import {
    isCheckboxSelected,
    isElectricalDisabled,
    isWaterCareDisabled,
    isFlueDrainDisabled,
    isElectricalVariantDisabled,
    isLidCoverDisabled,
} from "./utils";
import FieldGroup from "../../FieldGroup/FieldGroup";

const FormStepAccessories = ({
  flueDrainField,
  electricalField,
  woodenField, lidCoverField,
  waterCareField,
}) => {
  const {
      size,
    heaters: { heater, upgrades },
    accessories: { flueDrain, electrical, wooden, waterCare, lidCover },
  } = useContext(ConfigurationContext);
  const dispatch = useContext(DispatchContext);

  const handleFlueDrainChange = (option, checked) => {
    dispatch({ type: "SELECT_FLUE_DRAIN", payload: { option, checked } });
  };

  const isLidSelected = (option) => option.id === lidCover?.id

  const handleElectricalChange = (option, checked) => {
    dispatch({ type: "SELECT_ELECTRICAL", payload: { option, checked } });
  };

  const handleWoodenChange = (option, checked) => {
    dispatch({ type: "SELECT_WOODEN", payload: { option, checked } });
  };

  const handleWaterCareChange = (option, checked) => {
    dispatch({ type: "SELECT_WATER_CARE", payload: { option, checked } });
  };

    const handleLidCoverChange = (option) => {
        dispatch({ type: "SELECT_LID_COVER", payload: option });
    };

  const lidCoverGroupId = `${lidCoverField.name}-group`;
  const flueDrainGroupId = `${flueDrainField.name}-group`;
  const electricalGroupId = `${electricalField.name}-group`;
  const woodenGroupId = `${woodenField.name}-group`;
  const waterCareGroupId = `${waterCareField.name}-group`;

  return (
    <>
        <FieldGroup
            title={lidCoverField.title}
            details={lidCoverField.details}
            id={lidCoverGroupId}
        >
            {lidCoverField.options.map((option) => (
                <Checkbox
                    key={option.id}
                    type="radio"
                    name={lidCoverGroupId}
                    isChecked={isLidSelected(option)}
                    isDisabled={isLidCoverDisabled(option, heater, upgrades)}
                    {...option}
                    onChange={handleLidCoverChange}
                />
            ))}
        </FieldGroup>
      <FieldGroup
        title={flueDrainField.title}
        id={flueDrainGroupId}
        details={flueDrainField.details}
      >
        {flueDrainField.options.map((option) => (
          <Checkbox
            key={option.id}
            name={flueDrainGroupId}
            isChecked={isCheckboxSelected(option, flueDrain)}
            isDisabled={isFlueDrainDisabled(option, heater)}
            {...option}
            onChange={handleFlueDrainChange}
          />
        ))}
      </FieldGroup>

      <FieldGroup
        title={electricalField.title}
        id={electricalGroupId}
        details={electricalField.details}
      >
        {electricalField.options.map((option) => (
          <Checkbox
            key={option.id}
            size={size}
            name={electricalGroupId}
            isChecked={isCheckboxSelected(option, electrical)}
            isDisabled={isElectricalDisabled(option, electrical)}
            isVariantDisabled={(variant) =>
              isElectricalVariantDisabled(variant, option, electrical)
            }
            {...option}
            onChange={handleElectricalChange}
          />
        ))}
      </FieldGroup>

      <FieldGroup
        title={woodenField.title}
        id={woodenGroupId}
        details={woodenField.details}
      >
        {woodenField.options.map((option) => (
          <Checkbox
            key={option.id}
            name={woodenGroupId}
            isChecked={isCheckboxSelected(option, wooden)}
            {...option}
            onChange={handleWoodenChange}
          />
        ))}
      </FieldGroup>

      <FieldGroup
        title={waterCareField.title}
        id={waterCareGroupId}
        details={waterCareField.details}
      >
        {waterCareField.options.map((option) => (
          <Checkbox
            key={option.id}
            name={waterCareGroupId}
            isChecked={isCheckboxSelected(option, waterCare)}
            isDisabled={isWaterCareDisabled(option, waterCare)}
            {...option}
            onChange={handleWaterCareChange}
          />
        ))}
      </FieldGroup>
    </>
  );
};

export default FormStepAccessories;
